import {
  Accordion,
  AccordionSummary,
  Stack,
  styled,
  Typography,
} from '@mui/material';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(4, 0),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(2.5, 0),
  },

  [theme.breakpoints.down('md')]: {
    borderBottom: `1px solid ${theme.palette.invertedBorder?.LIGHT}`,
    borderTop: `1px solid ${theme.palette.invertedBorder?.LIGHT}`,
    ...theme.mixins.mobilePadding(),
    paddingTop: `${theme.spacing(2)} !important`,
    paddingBottom: `${theme.spacing(2)} !important`,
  },
}));

export const ServicesWrapper = styled(Stack)(({ theme }) => ({
  flexWrap: 'wrap',
  flexDirection: 'row',
  width: '100%',

  height: 'min-content',
  '>div': {
    width: '30%',
    [theme.breakpoints.down('xl')]: {
      width: '45%',
    },
  },
  gap: theme.spacing(3),

  [theme.breakpoints.down('md')]: {
    width: '100%',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(6),
    flexDirection: 'column',
    '>div': {
      width: '100%',
    },
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(1),
  },
}));

export const CategoriesWrapper = styled(Stack)(({ theme }) => ({
  minWidth: '250px',
  minHeight: '200px',
  marginRight: theme.spacing(5),
  gap: theme.spacing(3),
  borderRight: `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '10'}`,
}));

export const StyledCategoryItem = styled(Typography)<{ isSelected?: boolean }>(
  ({ theme, isSelected }) => ({
    color: theme.palette.invertedContent?.SECONDARY,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    paddingLeft: theme.spacing(2),
    border: 'none',
    textAlign: 'left',
    transition: 'color .2s linear',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    display: '-webkit-box',
    lineHeight: '22px !important',
    '*': {
      display: 'inline',
    },
    '&.Hovering': {
      color: theme.palette.blueColors?.PLUS_1,
    },
    ...(isSelected && {
      borderRight: `1px solid ${theme.palette.invertedContent?.PRIMARY}`,
      color: theme.palette.invertedContent?.PRIMARY,
    }),

    [theme.breakpoints.down('md')]: {
      borderRight: 'none',
      paddingLeft: 0,
    },
  })
);

export const StyledAccordionStack = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 'auto',
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
}));

export const StyledAccordion = styled(Accordion)(({}) => ({
  background: 'transparent',
  color: 'white',

  '&:before': {
    display: 'none',
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)<{
  isSelected: boolean;
}>(({ theme, isSelected }) => ({
  padding: theme.spacing(0, 0),

  '&.Transparent': {
    color: theme.palette.invertedContent?.TETRIARY,
  },
  '&.Opaque': {
    color: theme.palette.invertedContent?.PRIMARY,
  },
  '&.Active': {
    color: theme.palette.blueColors?.PLUS_1,
  },

  '>div': {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  '& .MuiAccordionSummary-content': {
    margin: theme.spacing(1, 0),
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: 'currentColor',
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)',
  },

  ...(isSelected && {
    borderBottom: `1px solid ${
      theme.palette.greyBackgroundColor?.SURFACE + '40'
    }`,
  }),
}));
